<template>
	<div class="field">
		<label :class="isFieldRequired ? 'req' : ''">{{ label }}</label>
		<p class="field_description" v-if="description" v-html="description"></p>
		<input :disabled="isDataUpdated" :class="isFieldHasError ? 'has_errors':''" name="name" type="text" maxlength="100"
		       :value="value" @change="changeData"/>
		<span v-if="objectKey === 'receipt_number'" class="verification-status">
        <span v-if="$parent.isReceiptVerifying" class="verifying">Проверка...</span>
        <span v-else-if="$parent.receiptVerificationStatus === true" class="verified">✓ Подтверждено</span>
        <span v-else-if="$parent.receiptVerificationStatus === false" class="failed">✗ Не найден</span>
      </span>
	</div>
</template>

<script>
export default {
	name: "BaseInput.vue",
	data() {
		return {
			currentValue: '',
		}
	},
	mounted() {
		this.currentValue = this.value;
	},
	props: {
		'label': {},
		'description': {},
		'value': {},
		'rules': {},
		'objectKey': {},
		'isFormSubmitted': {},
		'isDataUpdated': {},
		'isRequired': {default: false}
	},
	methods: {
		changeData(e) {
			this.currentValue = e.currentTarget.value;
			if (this.$parent.project) {
				this.$parent.project[this.objectKey] = e.currentTarget.value;
			}
			this.$emit('changeData', e.currentTarget.value, this.objectKey);
			if (typeof this.$parent.saveData === 'function') {
				this.$parent.saveData();
			}
			
		}
	},
	computed: {
		isFieldRequired() {
			if (typeof this.$parent.isFieldRequired === 'function') {
				return this.$parent.isFieldRequired(this.objectKey);
			} else {
				return this.isRequired;
			}
		},
		isFieldHasError() {
			return !!(this.isFieldRequired && this.isFormSubmitted && (this.currentValue === undefined || this.currentValue.length === 0));
		}
	}
}
</script>

<style scoped>
.field_description {
	font-size: 13px;
}
.input-wrapper {
	position: relative;
	display: flex;
	align-items: center;
}
.verification-status {
	margin-left: 10px;
	font-size: 14px;
}
.verifying {
	color: #666;
}
.verified {
	color: #4CAF50;
}
.failed {
	color: #F44336;
}
</style>